export const BASELAYER_SERVICE_STATUS_MESSAGES = [
  "Baselayer NaicsPrediction Requested",
  "Baselayer Enhanced Requested",
  "Baselayer Pep Requested",
];
